import { DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE } from '../../actions/types'

const initialState = undefined

export default function (state = 1, action = initialState) {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_ITINERARIO_EMBARQUE: {
      return action.payload
    }

    default:
      return state
  }
}
